export const isTermsOfUseAcceptedCookieName = 'isTermsOfUseAccepted';
